import { render, staticRenderFns } from "./doorEventView.vue?vue&type=template&id=0c804b9e"
import script from "./doorEventView.vue?vue&type=script&lang=js"
export * from "./doorEventView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports